import { TbChartTreemap } from "react-icons/tb";

const getDataFieldsDiskUsageTreechart = () => {
  return [
    {
      title: "Boxes",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Sub Boxes",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
    {
      title: "Metrics",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 500,
      valueType: Number,
    },
  ];
};

const getCustomizationFieldDiskUsageTreechart = () => {
  return [
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLabelDistusageTreeVisible",
      innerComponents: [
        {
          title: "Label Contents",
          type: "SELECT_BOX",
          reduxKey: "labelContentsforDistusagetree",
          options: [
            { label: "Category Name", value: "name" },
            { label: "Value", value: "value" },
          ],
          defaultValue: { label: "Category Name", value: "name" },
        },
        {
          title: "Font Color",
          type: "fontColor",

          reduxKey: "labelDistusageTreeFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Font Size",
          type: "range",
          defaultValue: 12,
          minValue: 10,
          maxValue: 40,
          reduxKey: "labelDistusageTreeFontSize",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },

    //textbox
    {
      title: "Title",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isTileVisible",
      innerComponents: [
        {
          title: "Title",
          type: "text",
          defaultValue: "title...",
          minValue: 0,
          maxValue: 20,
          reduxKey: "Title",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: false,
          reduxKey: "isTitleBold",
          isParent: true,
        },
        {
          title: "Title Color",
          type: "fontColor",
          reduxKey: "TitleFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
          defaultValue: "#bababa",
        },
        {
          title: "Title Size",
          type: "range",
          defaultValue: 25,
          minValue: 8,
          maxValue: 30,
          reduxKey: "TitleSize",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },

        {
          title: "Value Align",
          type: "textAlign",
          reduxKey: "valueAlign",
          defaultValue: "center",
        },
      ],
    },
  ];
};
const getDiskUsageTreeChartDetails = () => {
  return {
    chartType: "echarts",
    imageSrc: "/graph_img/Treechart.png",
    label: "Tree Map",
    value: "treechart",
    icon: <TbChartTreemap className="text-xl text-blue-950" />,
    fileName: "TreeChartComp.js",
  };
};
export {
  getDataFieldsDiskUsageTreechart,
  getCustomizationFieldDiskUsageTreechart,
  getDiskUsageTreeChartDetails,
};
